import { DateTime } from 'luxon'

const ageComparison = (birthday, num, compare_symbol) => {
  const newBirthday = DateTime.fromJSDate(new Date(birthday))
  const age = DateTime.now().diff(newBirthday, 'years').years
  try {
    return eval(`${age}${compare_symbol}${num}`)
  } catch (error) {
    return false
  }
}

export default function () {
  return {
    ageComparison
  }
}
